module.exports = __webpack_public_path__ + "img/symbol_8.4e2484f3.png";